<template>
    <section>
        <ds-modal
            :is-open="isEditManageLinkTypesModalOpen"
            :title.sync="modalTitle"
            :size="modalSize"
            show-back
            data-qa="edit-manage-link-types"
            @back="back"
        >
            <div data-qa="edit-manage-link">
                <div data-qa="type-name">
                    <p>Type Name</p>

                    <ds-input-field
                        v-model="typeName"
                    />
                </div>

                <div data-qa="max-number-of-links">
                    <p>Max Number of Links</p>

                    <ds-input-field
                        v-model="maxLinked"
                        type="number"
                        :step="1"
                        :min="0"
                    />
                </div>
            </div>

            <div>
                <ds-filled-button class="save-delete-button" data-qa="save-link" @click="save">
                    Save
                </ds-filled-button>

                <ds-outline-button v-if="showDelete" data-qa="delete-link" @click="deleteLink">
                    Delete
                </ds-outline-button>
            </div>
        </ds-modal>
    </section>
</template>
<script>
import axios from 'axios';

export default {

    props: {
        linkedContactTypes: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isEditManageLinkTypesModalOpen: false,
            modalSize: 'med',
            modalTitle: 'Link Type Information',
            manageLinkType: {},
            id: 0,
            typeName: '',
            maxLinked: 0,
        };
    },

    computed: {
        showDelete() {
            return this.id > 0;
        },
    },

    methods: {
        async save() {
            if (this.typeName?.trim() === '') {
                this.$toast({ message: 'Type name is required' });
            } else if ((this.id === 0) && this.linkedContactTypes.filter((type) => type?.typeName === this.typeName?.trim()).length > 0) {
                this.$toast({ message: `Sorry, the name ${this.typeName?.trim()} is already in your list` });
            } else if ((this.id > 0) && this.linkedContactTypes.filter((type) => (type?.typeName === this.typeName?.trim() && type?.id !== this.id)).length > 0) {
                this.$toast({ message: `Error with Database: Duplicate entry '${this.typeName?.trim()}' for key 'TypeName'` });
            } else if (this.maxLinked === 0) {
                this.$toast({ message: 'Max Number Of Links must be greater than 0.' });
            } else {
                const request = {
                    id: this.id,
                    typeName: this.typeName,
                    maxLinked: this.maxLinked,
                };

                let successMessage = 'link added successfully';

                try {
                    if (this.id === 0) {
                        // save
                        await axios.post('/app/contact/addLinkedContactType', request);
                    } else {
                        // update
                        await axios.put('/app/contact/updateLinkedContactType', request);
                        successMessage = 'link updated successfully';
                    }
                    this.$toast({ message: successMessage });
                    this.closeEditManageLinkTypes();
                } catch (error) {
                    this.$error({ message: 'error occurred while adding/updating manage link types' });
                }
            }
        },

        closeEditManageLinkTypes() {
            this.id = 0;
            this.typeName = '';
            this.maxLinked = 0;
            this.isEditManageLinkTypesModalOpen = false;
            this.$emit('openManageLinkTypes', true);
        },

        async deleteLink() {
            try {
                await axios.delete(`/app/contact/deleteLinkedContactType/${this.id}`);
                this.$toast({ message: 'link deleted successfully' });
            } catch (error) {
                this.$error({ message: error?.response?.data ?? 'error occurred while deleting manage link types' });
            }
            this.closeEditManageLinkTypes();
        },

        back() {
            this.id = 0;
            this.typeName = '';
            this.maxLinked = 0;
            this.isEditManageLinkTypesModalOpen = false;
            this.$emit('openManageLinkTypes', false);
        },

        editManageType(type) {
            this.id = Number(type?.id ?? 0);
            this.typeName = type?.typeName ?? '';
            this.maxLinked = Number(type?.maxLinked ?? 0);

            this.isEditManageLinkTypesModalOpen = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.save-delete-button {
    margin: $spacing-200;
}
</style>
